export type UnmatchedIds = string[];

const initialState: UnmatchedIds = [];

export default initialState;
